<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/universities`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Редактирование данных ВУЗа</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="universityId" class="form-label col-md-3">
            ID
          </label>
          <div class="col-md-9">
            <input class="form-control" id="universityId" type="number" step="1"
                   v-model="university.universityId">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">
            БИН
          </label>
          <div class="col-md-9">
            <input class="form-control" id="bin"  type="text" maxlength="12"
                   v-model="university.bin">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="name" class="form-label col-md-3">
            Наименование
          </label>
          <div class="col-md-9">
            <input class="form-control" id="name" type="text" v-model="university.nameRu">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="bic" class="form-label col-md-3">
            БИК
          </label>
          <div class="col-md-9">
            <input class="form-control" id="bic" type="text" v-model="university.bic">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="iik" class="form-label col-md-3">
            ИИК
          </label>
          <div class="col-md-9">
            <input class="form-control" id="iik" type="text" v-model="university.iik">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="region" class="form-label col-md-3">
          Область ВУЗа
        </label>
        <div class="col-md-9">
          <select v-model="university.region" id="region"
                  class="form-select">
            <option v-for="region in regions" :key="region.id" :value="region">
              {{ region.nameRu }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="manager" class="form-label col-md-3">
          Менеджер ФЦ
        </label>
        <div class="col-md-9">
          <select v-model="university.managerId" id="manager"
                  class="form-select">
            <option v-for="manager in managers" :key="manager.id" :value="manager.id">
              {{ manager.lastName }} {{ manager.firstName }} ({{ manager.email }})
            </option>
          </select>
        </div>
      </div>
    </div>

    <br/>

    <div class="row col-md-6">
      <div class="el-input-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="isNationalUniversity"
                 v-model="university.nationalUniversity"/>
          <label class="form-check-label" for="isNationalUniversity">
            Является национальным ВУЗом
          </label>
        </div>
      </div>
    </div>

    <div class="row col-md-6">
      <div class="el-input-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="isForeignUniversity"
                 v-model="university.foreignUniversity"/>
          <label class="form-check-label" for="isForeignUniversity">
            Является филалом зарубежного ВУЗа
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="page-footer justify-content-end"  v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import regionService from "@/services/regionService";
import userService from "@/services/userService";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  computed: {
    universityId() {
      return +this.$route.params.universityId;
    }
  },
  data() {
    return {
      isLoading: false,
      university: {
        id: null,
        nameRu: null
      },
      regions: [],
      managers: [],
    };
  },
  methods: {
    init() {
      if (this.universityId === 0) {
        this.university = {
          id: null,
          nameRu: null
        };
      } else {
        this.findById(this.universityId);
      }

      this.getRegions();
      this.getAllManagers();
    },
    async findById(universityId) {
      this.isLoading = true;
      this.university = await universityService.findById(universityId);
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;

        this.university = await universityService.save(this.university);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    async getRegions() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      const response = await regionService.getAll(params);
      this.regions = response.list;
    },
    async getAllManagers() {
      const response = await userService.getAllManagers();
      this.managers = response.list;
    },
    isAdmin() {
      return delegationService.isAdmin();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
</style>
